import { ContentTypes } from '../enums/ContentTypes';
import { Status } from '../enums/Status';
import { IContent } from '../interfaces/Content.interface';
import { IMedia } from '../interfaces/Media.interface';

// Initialize content state
export const INITIAL_CONTENT_STATE: IContent = {
  context: '',
  title: [],
  description: [],
  markdownText: [],
  sharingMessage: [],
  contentType: ContentTypes.TEXT,
  notificationInfo: {
    title: [],
    body: [],
  },
  media: {
    url: '',
    type: '',
    id: '',
    name: '',
  },
  thumbnail: '' as unknown as IMedia,
  status: Status.ACTIVE,
};
